import { VariantProps } from 'cva';

import { cva } from '../cva';

export const linkVariants = cva({
    base: [
        'text-blue inline-block rounded underline underline-offset-2 outline-none transition',
        'dark:text-white',
        'hover:text-black hover:dark:text-gray-100',
        'focus-visible:outline-blue focus-visible:outline-2 focus-visible:outline-offset-2',
        'pressed:scale-95',
    ],
});

export type LinkVariantProps = VariantProps<typeof linkVariants>;
